<template>
  <hr-form-dialog
    ref="dialog"
    size="sm"
    :title="$t('sessions.modals.videoSettings.title')"
    @hide="onDialogHide"
    @submit="onSubmit"
  >
    <div class="row q-col-gutter-md">
      <hr-list-select
        v-model="selectedCamera"
        :options="cameraOptions"
        option-value="deviceId"
        emit-object
        no-checkmark
        :label="$t('sessions.modals.videoSettings.selectCamera')"
        hide-bottom-space
        class="col-12"
      >
        <template #option-leading="{ opt }">
          <hr-icon
            v-if="opt.deviceId === activeCamera"
            name="done"
          />
        </template>
      </hr-list-select>
      <hr-list-select
        v-if="!isMobilePlatform"
        v-model="selectedMicrophone"
        :options="microphoneOptions"
        option-value="deviceId"
        emit-object
        no-checkmark
        :label="$t('sessions.modals.videoSettings.selectMicrophone')"
        hide-bottom-space
        class="col-12"
      >
        <template #option-leading="{ opt }">
          <hr-icon
            v-if="opt.deviceId === activeMicrophone"
            name="done"
          />
        </template>
      </hr-list-select>
      <hr-list-select
        v-if="!isMobilePlatform"
        v-model="selectedSpeaker"
        :options="speakerOptions"
        option-value="deviceId"
        emit-object
        no-checkmark
        :label="$t('sessions.modals.videoSettings.selectedSpeaker')"
        hide-bottom-space
        class="col-12"
      >
        <template #option-leading="{ opt }">
          <hr-icon
            v-if="opt.deviceId === activeSpeaker"
            name="done"
          />
        </template>
      </hr-list-select>
    </div>
    <template #actions>
      <hr-dismiss-btn
        :label="$t('common.buttonCancel')"
        @click="hide"
      />
      <hr-confirm-btn
        type="submit"
        :label="$t('common.buttonSave')"
        :disable="!(selectedCamera || selectedMicrophone || selectedSpeaker)"
        data-e2e="button-save"
      />
    </template>
  </hr-form-dialog>
</template>

<script>
import {
  HrConfirmBtn,
  HrDismissBtn,
  HrFormDialog,
  HrIcon,
  HrListSelect,
} from 'src/design-system';

export default {
  name: 'VideoSettings',

  components: {
    HrConfirmBtn,
    HrDismissBtn,
    HrFormDialog,
    HrIcon,
    HrListSelect,
  },

  props: {
    zoomClient: {
      type: Object,
      default: () => ({}),
      required: true,
    },
  },

  emits: ['ok', 'hide'],

  data() {
    return {
      stream: null,
      selectedCamera: null,
      cameraOptions: [],
      activeCamera: null,
      selectedMicrophone: null,
      microphoneOptions: [],
      activeMicrophone: null,
      selectedSpeaker: null,
      speakerOptions: [],
      activeSpeaker: null,
    };
  },

  computed: {
    isMobilePlatform() {
      return this.$q.platform.is.capacitor && (this.$q.platform.is.ios || this.$q.platform.is.android);
    },
  },

  mounted() {
    this.stream = this.zoomClient.getMediaStream();
    if (!this.stream) {
      return;
    }

    this.getCameras();
    this.getActiveCamera();

    this.getMicrophones();
    this.getActiveMicrophone();

    this.getSpeakers();
    this.getActiveSpeaker();

    this.selectedCamera = this.cameraOptions.find((camera) => camera.deviceId === this.activeCamera) || null;
    this.selectedMicrophone = this.microphoneOptions.find(
      (microphone) => microphone.deviceId === this.activeMicrophone,
    ) || null;
    this.selectedSpeaker = this.speakerOptions.find((speaker) => speaker.deviceId === this.activeSpeaker) || null;
  },

  methods: {
    onSubmit() {
      this.$emit('ok', {
        camera: this.selectedCamera,
        microphone: this.selectedMicrophone,
        speaker: this.selectedSpeaker,
      });

      this.hide();
    }, // onSubmit()

    onDialogHide() {
      this.hide();
      this.$emit('hide');
    }, // onDialogHide()

    show() {
      this.$refs.dialog.show();
    }, // show()

    hide() {
      if (this.$refs.dialog) {
        this.$refs.dialog.hide();
      }
    }, // hide()

    getCameras() {
      this.cameraOptions = this.stream?.getCameraList() || [];
    }, // getCameras

    getActiveCamera() {
      this.activeCamera = this.stream?.getActiveCamera() || null;
    }, // getActiveCamera

    getMicrophones() {
      this.microphoneOptions = this.stream?.getMicList() || [];
    }, // getMicrophones

    getActiveMicrophone() {
      this.activeMicrophone = this.stream?.getActiveMicrophone() || null;
    }, // getActiveMicrophone

    getSpeakers() {
      this.speakerOptions = this.stream?.getSpeakerList() || [];
    }, // getSpeakers

    getActiveSpeaker() {
      this.activeSpeaker = this.stream?.getActiveSpeaker() || null;
    }, // getActiveSpeaker
  },
};
</script>
